import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/globals.css';
import './index.css';
import App from './App';
import { initAnalytics, trackPageView } from './utils/analytics';

// Initialize GA4 early and send first page_view immediately (fixes homepage first-load + UTM tracking)
initAnalytics();
trackPageView({
  path: `${window.location.pathname}${window.location.search}${window.location.hash}`,
  title: document.title
});

// Ensure any previously installed Service Workers are removed to avoid stale caching
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister().then((unregistered) => {
          if (unregistered) {
            console.log('Unregistered existing service worker:', registration.scope);
          }
        });
      });
    }).catch((err) => {
      console.log('Service worker cleanup error:', err);
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);